import { Box, IconButton, Popover, Typography } from '@mui/material';
import _ from 'lodash';
import React, { useState } from 'react';
import { Attachment } from '../../../types/Attachment';
import AttachmentItem from './AttachmentItem';

interface IAttachmentPopoverProps {
  attachments: Attachment[];
}

const AttachmentPopover: React.FC<IAttachmentPopoverProps> = ({ attachments }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);
  const id = open ? 'attachments-popover' : undefined;

  if (_.isEmpty(attachments)) return null;

  const handleOpen = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton onClick={handleOpen} size="small">
        <Typography variant="body2">+{attachments.length}</Typography>
      </IconButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{
          paper: {
            sx: { maxHeight: '10rem', width: '20rem', overflowY: 'auto', p: 2 },
          },
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {_.map(attachments, (attachment) => (
            <AttachmentItem key={attachment.key} attachment={attachment} showSize />
          ))}
        </Box>
      </Popover>
    </>
  );
};

export default AttachmentPopover;
